<template>
  <dx-data-grid
    :show-borders="true"
    :ref="'child-grid-' + templateData.key"
    :columns="childGridColumns"
    :data-source="dataSource"
    @editor-preparing="onEditorPreparing"
    @content-ready="onContentReady"
    @init-new-row="onInitNewRow"
    @row-removed="onRowRemoved"
    :columnChooser="{
      enabled: false,
    }"
  >
    <DxSearchPanel :visible="false" />
    <DxEditing
      :allow-deleting="allowEdit"
      :allow-updating="allowEdit"
      mode="cell"
    />
  </dx-data-grid>
</template>
<script>
import { DxDataGrid } from "devextreme-vue/data-grid";
import BaseViewMixin from "../../src/v1/_mixins/base.view";

export default {
  components: { DxDataGrid },
  props: {
    templateData: {
      type: Object,
      default: () => {},
    },
    parentModel: {
      type: Object,
      default: () => {},
    },
    childGridColumns: {
      type: Array,
      default: () => {
        return [];
      },
    },
    allowEdit: {
      type: Boolean,
      default: true,
    },
    onNewRowInitializedCallback: {
      type: Function,
      default: () => {},
    },
    onRowRemovedCallback: {
      type: Function,
      default: () => {},
    },
    onEditorPreparingCallback: {
      type: Function,
      default: () => {},
    },
    baseLineBase: {
      type: Object,
      default: () => {},
    },
    dataSource: {
      type: Array,
      default: () => [],
    },
  },
  mixins: [BaseViewMixin],
  data() {
    return {};
  },
  created() {
    if (this.allowEdit && this.dataSource.length == 0) this.onAddClickHandler();
  },
  methods: {
    onEditorPreparing(e) {
      this.onEditorPreparingCallback(e);
    },

    onInitNewRow(e) {
      this.onNewRowInitializedCallback(e);
    },
    onRowRemoved(e) {
      this.onRowRemovedCallback(e);
    },

    onAddClickHandler() {
      let obj = Object.assign({}, this.baseLineBase);
      this.dataSource.push(obj);
      if (this.$refs["child-grid-" + this.templateData.key]) {
        let grid = this.$refs["child-grid-" + this.templateData.key].instance;

        grid.repaint();
      }
    },
  },
  computed: {
    noOfRecords() {
      return this.dataSource.length;
    },
  },
  watch: {
    noOfRecords: {
      handler: function(value) {
        // add a record if the no of items in the datasource is 0
        if (this.allowEdit && value == 0) {
          this.onAddClickHandler();
        }
      },
    },
  },
};
</script>
<style>
/* @import "../dx-styles.scss"; */
</style>
